<template>
  <!-- <v-app :class="{ 'nav-open': $sidebar.showSidebar }" v-on:click.native="getAuth()"> -->
  <v-app :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <!-- <div class="auth-error" v-show="noAuth" @click="getCookie('reload')">
      <span><i class="ti-info-circle"></i> Сессия истекла. Нажмите, чтобы авторизоваться</span>
    </div>
    <div v-show="noAuth" class="cloneWin"></div> -->
    <router-view></router-view>
  </v-app>
</template>

<script>
import Vue from 'vue'
import VueCookies from "vue-cookies-reactive";
import GlobalRequest from "@/plugins/globalRequest"

Vue.use(VueCookies)
export default {
  components: {VueCookies, GlobalRequest},
  data() {
    return {
      noAuth: false,
    }
  },
  mounted() {
    this.getCookie("reload")

    setInterval(() => {
      this.getCookie()
    }, 75000); // 1 мин и еще чуть-чуть
  },
  methods: {
    getCookie(flag) {
      if(document.location.pathname != '/authentication') {
        let res = document.cookie.split('; ').reduce((acc, item) => {
          const [name, value] = item.split('=')
          acc[name] = value
          return acc
        }, {})
        if(res.token == undefined || res.token == "") { 
          if (flag == "reload") {
            this.noAuth = true
            this.$router.push(
              {
                name: "authentication",
                meta: {
                  last_path: this.$route.name,
                }
              }  
            )
            this.noAuth = false
          }
          else {
            this.noAuth = true
          }
        }
      }
    },
  },
  
};
</script>

<style lang="scss">
.auth-error {
  position: fixed;
  top: 0;
  z-index: 9999;
  display: block;
  margin: 0 auto;
  text-align: center;
  width: 100%;
  cursor: pointer;
}
.auth-error span {
  background: #b80000;
  border-radius: 0 0 10px 10px;
  margin: 0 auto;
  padding: 7px 25px;
  color: #fff;
  transition: 0.3s;
}
.auth-error span:hover {
  background: #d11414;
  border-radius: 0 0 10px 10px;
  margin: 0 auto;
  padding: 7px 25px;
  color: #fff;
}
.cloneWin {
  z-index: 9998;
  width: 100%;
  height: 100%;
  position: fixed;
  background: rgba(255, 255, 255, 0.2);
}
.vue-notifyjs.notifications {
  .alert {
    z-index: 10000;
  }

  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }

  .list-item {
    display: inline-block;
    margin-right: 10px;
  }

  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }

  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }

  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }

  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}
</style>
